var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFormIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m459.406 132.927-128.533-128.533c-2.812-2.813-6.628-4.394-10.606-4.394h-216.9c-30.419 0-55.167 24.748-55.167 55.166v401.667c0 30.419 24.748 55.167 55.166 55.167h305.268c30.419 0 55.166-24.748 55.166-55.167v-313.3c0-3.978-1.58-7.793-4.394-10.606zm-124.139-81.714 77.319 77.32h-52.152c-13.877 0-25.167-11.29-25.167-25.167zm73.367 430.787h-305.268c-13.876 0-25.166-11.29-25.166-25.167v-401.667c0-13.876 11.29-25.166 25.166-25.166h201.9v73.366c0 30.419 24.748 55.167 55.167 55.167h73.367v298.3c0 13.877-11.289 25.167-25.166 25.167z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m191.733 224.933h-64.267c-8.284 0-15 6.716-15 15v64.267c0 8.284 6.716 15 15 15h64.267c8.284 0 15-6.716 15-15v-64.268c0-8.284-6.715-14.999-15-14.999zm-15 64.267h-34.267v-34.268h34.267z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m191.733 353.467h-64.267c-8.284 0-15 6.716-15 15v64.267c0 8.284 6.716 15 15 15h64.267c8.284 0 15-6.716 15-15v-64.267c0-8.284-6.715-15-15-15zm-15 64.266h-34.267v-34.267h34.267z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m241 239.933c0 8.284 6.716 15 15 15h64.267c8.284 0 15-6.716 15-15s-6.716-15-15-15h-64.267c-8.284 0-15 6.715-15 15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m384.533 289.2h-128.533c-8.284 0-15 6.716-15 15s6.716 15 15 15h128.533c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m256 383.467h64.267c8.284 0 15-6.716 15-15s-6.716-15-15-15h-64.267c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m384.533 417.733h-128.533c-8.284 0-15 6.716-15 15s6.716 15 15 15h128.533c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m127.467 110.333h80.333c8.284 0 15-6.716 15-15s-6.716-15-15-15h-80.333c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m127.467 174.6h128.533c8.284 0 15-6.716 15-15s-6.716-15-15-15h-128.533c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormIcon);
export default __webpack_public_path__ + "static/media/form-icon.68e88dea.svg";
export { ForwardRef as ReactComponent };